import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import DataTable, { TableStyles } from 'react-data-table-component';

import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import GridPanel from "./grid-panel";
import LocalStorageConstant from "../../../../constants/localstroage.constant";

import Helpers from "../../../../utils/helpers";
import getCurrentUserService from "../../../../services/user/user.service";
import LoadingScreen from "../../../common/Loading";
import SitesService from "../../../../services/AuraCamera/sites/sites.service";
import TokenService from "../../../../services/autentication/token.service";

interface ColumnDef {
  header?: string;
  body?: any;
  name?: any;
  cell?: any;
  selector?: any;
  sortable?: boolean;
  style?: any;
  width?: any;
  sortFunction?: any;
  omit?: any;
}
const dataTableStyles: TableStyles = {
  subHeader: {
    style: {
      paddingLeft: "15px",
      paddingRight: "15px",
    },
  },
  head: {
    style: {
      height: "38px",
      opacity: "1",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#e5e5e5",
      borderTop: "1px solid rgba(0,0,0,0.07)",
      justifyContent: "space-between",
      fontWeight: "bold",
      paddingLeft: "13px",
      paddingRight: "13px",
      height: "38px",
      opacity: "1",
    },
  },
  cells: {
    style: {
      background: "transparent",
      borderBottom: "#D0D0CE",
      paddingLeft: "13px",
      paddingRight: "13px",
      minHeight: "38px",
    },
  },
};

interface Customer {
  SurveyName?: string;
  name?: string;
  Date?: string;
  Status?: any;
  Source?: any;
  Size?: any;
  Percent?: number;
}

const AllSurveyTable = (props: any) => {
  const { t } = useTranslation();
  var navigate = useNavigate();
  const selectDaysDpDown = useRef<any>(null);
  const [currentPageData, setCurrentPageData] = useState<Customer[]>([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerID, setSelectedCustomerID] = useState("");
  const [userData, setUserData] = useState<any>("");
  const [isLoading, isLoadingUpdate] = useState(false);
  const [loadingText, loadingTextUpdate] = useState("");
  const [textForLDR, setTextForLDR] = useState("");
  const [checkFlag, UpdateCheckflag] = useState(false);

  const session = window.localStorage;
  // const userData = JSON.parse(localStorage.getItem('user') as any);
  useEffect(() => {
    if (props?.filteredValues?.length > 0) {
      var filtered_by_size_array = props?.filteredValues;
      setCurrentPageData(filtered_by_size_array);
    } else {
      setCurrentPageData([]);
    }
    let selected_dashboard_customer_name: any = JSON.parse(
      session.getItem("customer-selected") as any
    );

    if (selected_dashboard_customer_name != "") {
      setSelectedCustomer(
        selected_dashboard_customer_name?.dashboardSelectedCustomer?.name
      );
      setSelectedCustomerID(
        selected_dashboard_customer_name?.dashboardSelectedCustomer?.customerID
      );
    }
  }, [props]);

  useEffect(() => {
    isLoadingUpdate(true);
    //if (userData?.length > 0) {
    const getUser = TokenService.getUser();
    if (getUser == null) {
      UpdateCheckflag(false);
    } else {
      UpdateCheckflag(true);
    }
    setUserData(getUser);
    if (getUser && getUser?.customerID) {
      SitesService.sitesGetAllCustomers().then((res) => {
        if (res?.length > 0) {
          const foundCustomer: any = res.filter(
            (itm: any) => itm?.customerID == getUser?.customerID
          );
          let foundCustomerUser: any = "";
          if (foundCustomer?.length == 0) {
            foundCustomerUser = res.filter(
              (itm: any) => itm?.name == getUser?.customerID
            );
          }

          if (
            foundCustomer[0]?.isLDR == true ||
            foundCustomerUser[0]?.isLDR == true
          ) {
            setTextForLDR("Company Name");
            props.setLDRStatus("Company Name");
          } else {
            if (getUser?.superAdmin == false && getUser?.globalAdmin == false) {
              setTextForLDR("Service Provider");
              props.setLDRStatus("Service Provider");
            } else {
              setTextForLDR("Company Name");
              props.setLDRStatus("Company Name");
            }
          }

          setTimeout(() => {
            isLoadingUpdate(false);
          }, 2000);
        }
      });
    } else {
      setTextForLDR("Company Name");
      props.setLDRStatus("Company Name");
      setTimeout(() => {
        isLoadingUpdate(false);
      }, 2000);
    }

    // getCurrentUserService.getCurrentUser().then((res) => {
    //   if (res?._id) {
    //     isLoadingUpdate(false)
    //     setUserData(res)
    //   } else {
    //     isLoadingUpdate(false)
    //     setUserData("")
    //   }
    //   //fetchData();
    //   SitesService.sitesGetAllCustomers().then((res) => {
    //     if (res?.length > 0) {
    //       console.log(userData?.customerID)
    //       const foundCustomer: any = res.filter((itm: any) => itm?.customerID == userData?.customerID)
    //       console.log(foundCustomer)
    //       if (foundCustomer && (foundCustomer[0]?.isLDR == true)) {
    //         setTextForLDR("Service Provider")
    //       }
    //     }
    //   });
    // })
    //}
  }, [checkFlag == false]);

  // const fetchData = useCallback(async () => {
  //   const data = await SitesService.sitesGetAllCustomers().then((res) => {
  //     if (res?.length > 0) {
  //       const foundCustomer: any = res.filter((itm: any) => itm?.customerID == userData?.customerID)
  //       console.log(foundCustomer)
  //       if (foundCustomer && (foundCustomer[0]?.isLDR == true)) {
  //         setTextForLDR("Service Provider")
  //       }
  //     }
  //   });
  // }, [textForLDR]);
  const siteNameSorting = (rowA: any, rowB: any) => {
    const a = rowA.siteName.toLowerCase();
    const b = rowB.siteName.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };
  const companyNameSorting = (rowA: any, rowB: any) => {
    const a = rowA.companyName.toLowerCase();
    const b = rowB.companyName.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };
  const contactNameSorting = (rowA: any, rowB: any) => {
    const a = rowA.contactName.toLowerCase();
    const b = rowB.contactName.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };
  const stateSorting = (rowA: any, rowB: any) => {
    const a = rowA.state.toLowerCase();
    const b = rowB.state.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };
  const notesSorting = (rowA: any, rowB: any) => {
    const a = rowA.notes.toLowerCase();
    const b = rowB.notes.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  const columns: ColumnDef[] = [
    {
      name: "",
      selector: (row: any) => row.created_date,
      cell: (row: any) => {
        return <>{row.created_date}</>;
      },
      omit: true,
    },
    {
      name: "Site Name",
      selector: (row: any) => row.siteName,
      cell: (row: any) => {
        return <>{row.siteName}</>;
      },
      sortable: true,
      sortFunction: siteNameSorting,
    },
    {
      name: textForLDR,
      selector: (row: any) =>{
        let temp_contact_name = row.companyName;
        if (temp_contact_name == null || temp_contact_name == undefined) {
          temp_contact_name = "";
        } else {
          let lowerCaseStr = temp_contact_name.toLowerCase();
          lowerCaseStr = lowerCaseStr.trim();
          temp_contact_name = lowerCaseStr;
        }
        return temp_contact_name;
      },
      cell: (row: any) => {
        return row.companyName;
      },
      // width: "22%",
      sortable: true,
      // sortFunction: companyNameSorting,
    },
    {
      name: "Location",
      selector: (row: any) => {
        let temp_city = row.city;
        let temp_state = row.state;
        let temp_zip = row.zip;

        if(temp_city == null || temp_city == undefined || temp_city == ""){
          temp_city = ""
        }else{
          temp_city = temp_city.trim();
        }

        if(temp_state == null || temp_state == undefined || temp_state == ""){
          temp_state = ""
        }else{
          temp_state = temp_state.trim();
        }

        if(temp_zip == null || temp_zip == undefined || temp_zip == ""){
          temp_zip = ""
        }else{
          temp_zip = temp_zip.trim();
        }
        let complete_location = temp_city + temp_state + temp_zip;
        let lowerCaseStr = complete_location.toLowerCase().trim();

        return lowerCaseStr;
      },
      cell: (row: any) => {
        return (
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <span>
              {row.city}, {row.state} ,{row.zip}
            </span>
          </div>
        );
      },
      sortable: true,
      width: "130px",
      // sortFunction: stateSorting,
    },
    {
      name: "Site Contact Name",
      selector: (row: any) => {
        let temp_contact_name = row.contactName;
        if (temp_contact_name == null || temp_contact_name == undefined) {
          temp_contact_name = "";
        } else {
          let lowerCaseStr = temp_contact_name.toLowerCase();
          lowerCaseStr = lowerCaseStr.trim();
          temp_contact_name = lowerCaseStr;
        }
        return temp_contact_name;
      },
      cell: (row: any) => {
        return row.contactName;
      },
      sortable: true,
      width: "140px",
      // sortFunction: contactNameSorting,
    },
    {
      name: "Phone",
      selector: (row: any) => row.phone,
      cell: (row: any, index: number, column: any, id: number) => {
        return row.phone;
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Notes",
      selector: (row: any) => {
        let temp_contact_name = row.notes;
        if (temp_contact_name == null || temp_contact_name == undefined || temp_contact_name == "") {
          temp_contact_name = "";
        } else {
          let lowerCaseStr = temp_contact_name.toLowerCase();
          lowerCaseStr = lowerCaseStr.trim();
          temp_contact_name = lowerCaseStr;
        }
        return temp_contact_name;
      },
      cell: (row: any, index: number, column: any, id: number) => {
        return row.notes;
      },
      sortable: true,
      width: "110px",
      // sortFunction: notesSorting,
    },
    {
      name: "Status",
      selector: (row: any) => row.status,
      cell: (row: any, index: number, column: any, id: number) => {
        return (
          <>
            <span
              className={`badge ${
                row.status === "true" ? "bg-success" : "bg-light"
              }`}
            >
              {row.status === "true" ? "Active" : "Inactive"}
            </span>
          </>
        );
      },
      sortable: false,
      width: "90px",
    },
    {
      name: "Actions",
      cell: (row: any, index: number, column: any, id: number) => {
        if (getUser?.superAdmin == false && getUser?.globalAdmin == false) {
          if (textForLDR == "Company Name") {
            return <></>;
          } else {
            return (
              <>
                <div className="action-icons">
                  <span
                    className="material-symbols-outlined"
                    onClick={() => {
                      navigate(`/aura-camera/sites-creation/${row._id}`);
                    }}
                  >
                    edit
                  </span>
                </div>
              </>
            );
          }
        } else {
          return <></>;
        }
      },
      width: "80px",
    },
  ];

  const liveData = currentPageData?.length > 0 ? currentPageData : [];

  const filteredItems = liveData?.filter((item: any) => {
    let regex = /"(\\.|[^"\\])*"/g;
    var exactMatchText: any =
      filterText != null
        ? filterText.match(regex)?.[0].replace(/"/g, "")
        : null;

    if (exactMatchText) {
      return (
        item?.city?.toString().toLowerCase() == exactMatchText?.toLowerCase() ||
        item?.siteName?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.companyName?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.state?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.zipCode?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.contactName?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.phoneNumber?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.notes?.toString().toLowerCase() == exactMatchText?.toLowerCase()
      );
    } else {
      return (
        item?.city
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.siteName
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.companyName
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.state
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.zipCode
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.contactName
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.phoneNumber
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.notes
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase())
      );
    }
  });
  const getUser = TokenService.getUser();

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      // <FilterComponent onFilter={(e: any) => setFilterText(e?.target?.value)} onClear={handleClear} filterText={filterText} />
      <div className="table-wrapper_btn">
        <LoadingScreen isLoading={isLoading} text={loadingText} />
        <div className="d-flex flex-row justify-content-start align-items-center table-search">
          <label className="custom_common_label">
            {t("SearchLabel")}: &nbsp;&nbsp;&nbsp;{" "}
          </label>
          <div className="inputGroup">
            <div className="input-block">
              <input
                type="text"
                name="sitebulkuploadsearch"
                id="sitebulkuploadsearch"
                className="form-control input-sm"
                onChange={(e: any) => setFilterText(e?.target?.value)}
                value={filterText}
              />
              <span className="material-symbols-outlined">search</span>
            </div>
            <div className="searchClear">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => handleClear()}
              >
                {" "}
                X
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      {getUser?.superAdmin === false && getUser?.globalAdmin == false ? (
        textForLDR == "Company Name" ? (
          <div className="site-table_btn">
            <p>Please contact admin to Add Site</p>
          </div>
        ) : (
          <div className="site-table_btn">
            <button
              className="btn btn-primary"
              onClick={() => {
                navigate(`/aura-camera/sites-creation`);
              }}
            >
              Add New Site
            </button>
          </div>
        )
      ) : (
        ""
      )}
      {props.isGrid && props.isGrid ? (
        <div className="grid-block sites-grid-block" id="grid-block">
          <div className="row">
            <GridPanel
              filteredItems={liveData}
              getUser={getUser}
              textForLDR={textForLDR}
            />
          </div>
        </div>
      ) : (
        <div className="table-responsive sites-table" id="table-block">
          <DataTable
            columns={columns}
            data={filteredItems}
            highlightOnHover={true}
            defaultSortFieldId="1"
            defaultSortAsc={false}
            pagination={true}
            subHeader
            subHeaderComponent={
              liveData?.length > 0 ? subHeaderComponentMemo : []
            }
            responsive={true}
            striped={true}
            className={"cusTableRes"}
            // paginationPerPage={5}
            // paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
            customStyles={dataTableStyles}
            // sortIcon={sortIcon}
          />
        </div>
      )}
    </>
  );
};

export default AllSurveyTable;
